// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page layout root */
#page-layout {
    width: 100%;
    min-width: 0; /* важно для мобильных */
    display: flex;
    flex-direction: row;
}

/* Main content area (to the right of fixed sidebar on desktop) */
#page-content {
    width: 100%;
    min-width: 0;

    /* desktop offset from fixed sidebar */


    /* do not clamp width by percent; let it be responsive */
    max-width: none;

    min-height: calc(var(--vh, 1vh) * 100);
    background-color: var(--cl-light);
}

/* Optional content wrappers */
.content-wmax {
    width: 100%;

    margin-left: auto;
    margin-right: auto;
}

.content-w100 {
    width: 100%;
}

/* ===== Mobile ===== */
@media (max-width: 768px) {
    #page-layout {
        flex-direction: column;
        min-width: 0;
    }

    #page-content {
        margin-left: 0;           /* sidebar is overlay now */
        min-height: calc(var(--vh, 1vh) * 100);
        padding-top: 0;           /* topbar учитывается через #root padding-top или отдельно */
    }
}
.pageContentInner {
    /* desktop padding comes from pt-l/pb-l utilities */
}

@media (max-width: 768px) {
    .pageContentInner.pt-l { padding-top: 12px !important; }
    .pageContentInner.pb-l { padding-bottom: 12px !important; }
}
`, "",{"version":3,"sources":["webpack://./src/Components/PageLayout/Page.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,WAAW;IACX,YAAY,EAAE,wBAAwB;IACtC,aAAa;IACb,mBAAmB;AACvB;;AAEA,iEAAiE;AACjE;IACI,WAAW;IACX,YAAY;;IAEZ,sCAAsC;;;IAGtC,wDAAwD;IACxD,eAAe;;IAEf,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA,8BAA8B;AAC9B;IACI,WAAW;;IAEX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA,uBAAuB;AACvB;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,cAAc,YAAY,2BAA2B;QACrD,sCAAsC;QACtC,cAAc,YAAY,4DAA4D;IAC1F;AACJ;AACA;IACI,mDAAmD;AACvD;;AAEA;IACI,yBAAyB,4BAA4B,EAAE;IACvD,yBAAyB,+BAA+B,EAAE;AAC9D","sourcesContent":["/* Page layout root */\r\n#page-layout {\r\n    width: 100%;\r\n    min-width: 0; /* важно для мобильных */\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n\r\n/* Main content area (to the right of fixed sidebar on desktop) */\r\n#page-content {\r\n    width: 100%;\r\n    min-width: 0;\r\n\r\n    /* desktop offset from fixed sidebar */\r\n\r\n\r\n    /* do not clamp width by percent; let it be responsive */\r\n    max-width: none;\r\n\r\n    min-height: calc(var(--vh, 1vh) * 100);\r\n    background-color: var(--cl-light);\r\n}\r\n\r\n/* Optional content wrappers */\r\n.content-wmax {\r\n    width: 100%;\r\n\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n.content-w100 {\r\n    width: 100%;\r\n}\r\n\r\n/* ===== Mobile ===== */\r\n@media (max-width: 768px) {\r\n    #page-layout {\r\n        flex-direction: column;\r\n        min-width: 0;\r\n    }\r\n\r\n    #page-content {\r\n        margin-left: 0;           /* sidebar is overlay now */\r\n        min-height: calc(var(--vh, 1vh) * 100);\r\n        padding-top: 0;           /* topbar учитывается через #root padding-top или отдельно */\r\n    }\r\n}\r\n.pageContentInner {\r\n    /* desktop padding comes from pt-l/pb-l utilities */\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .pageContentInner.pt-l { padding-top: 12px !important; }\r\n    .pageContentInner.pb-l { padding-bottom: 12px !important; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
